import React, {
  Component,
} from 'react'
import debounce from 'lodash/debounce'
import PropTypes from 'prop-types'
import Formsy from 'formsy-react'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import FormsyInput from './FormsyInput'

class FormsySize extends Component {
  constructor() {
    super()
    this.handleChange = debounce(this.handleChange.bind(this), 100)
  }

  handleChange() {
    if (this.form) {
      const model = this.form.getModel()
      const resolvedModel = model[this.props.name]
      this.props.onChange(resolvedModel)
    }
  }
  render() {
    const {
      name,
      value,
      label,
      onChange,
      ...props
    } = this.props
    return (
      <Formsy.Form
        ref={(form) => this.form = form}
        onValid={this.handleChange}
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
        }}
      >
        <FormsyInput.UnitSize
          name={name}
          floatingLabelText={label}
          value={value}
          style={{ width: 'initial' }}
          extraValidation={(_, val) => val === '100%'}
          {...props}
        />
        <FormCheckbox
          label="100%"
          value={value === '100%'}
          onChange={(val) => onChange(val ? '100%' : '')}
          style={{
            width: 'initial',
            marginBottom: 10,
            display: 'inline-block',
          }}
        />
      </Formsy.Form>
    )
  }
}

FormsySize.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
}
FormsySize.defaultProps = {
  value: '',
  label: '',
}

export default FormsySize



// WEBPACK FOOTER //
// ./src/components/formsy/FormsySize.js